import { useState, useEffect, useRef, useCallback } from 'react';


// ─── Fake live activity data (simulates real calls across all builds) ────
const SAMPLE_TOOLS = [
  // Crypto Market Analytics
  { build: 'drc-pattern-scanner', tool: 'get-candles', params: 'BTCUSDT 1d', ms: 142, price: 0.02 },
  { build: 'drc-pattern-scanner', tool: 'list-symbols', params: '31 pairs', ms: 89, price: 0.02 },
  { build: 'drc-pattern-scanner', tool: 'run-analysis', params: 'MA crossover', ms: 340, price: 0.02 },
  { build: 'drc-pattern-scanner', tool: 'run-backtest', params: 'RSI strategy', ms: 1240, price: 0.02 },
  // DocForge
  { build: 'docforge', tool: 'invoice', params: 'Client: Acme Corp', ms: 820, price: 0.05 },
  { build: 'docforge', tool: 'resume', params: 'Software Engineer', ms: 940, price: 0.05 },
  // CodeForge
  { build: 'codeforge', tool: 'review', params: 'auth.ts 142 lines', ms: 2100, price: 0.05 },
  { build: 'codeforge', tool: 'generate', params: 'REST API endpoint', ms: 3200, price: 0.05 },
  // LocalLLM
  { build: 'localllm', tool: 'generate', params: 'Summarize article', ms: 4500, price: 0.02 },
  { build: 'localllm', tool: 'code', params: 'Python sort algo', ms: 3800, price: 0.02 },
  // StockForge
  { build: 'stockforge', tool: 'quote', params: 'AAPL', ms: 310, price: 0.02 },
  { build: 'stockforge', tool: 'compare', params: 'MSFT,GOOGL,AMZN', ms: 680, price: 0.02 },
  { build: 'stockforge', tool: 'history', params: 'TSLA 1mo', ms: 420, price: 0.02 },
  // WebScraper
  { build: 'webscraper', tool: 'scrape', params: 'news.ycombinator.com', ms: 1800, price: 0.02 },
  { build: 'webscraper', tool: 'readability', params: 'blog post extract', ms: 1200, price: 0.02 },
  // Whisper
  { build: 'whisper', tool: 'transcribe', params: '45s audio clip', ms: 8200, price: 0.08 },
  // QuickChart
  { build: 'quickchart', tool: 'chart', params: 'bar chart 5 series', ms: 380, price: 0.005 },
  { build: 'quickchart', tool: 'qr', params: 'https://invoke-api.com', ms: 120, price: 0.005 },
  { build: 'quickchart', tool: 'wordcloud', params: '200 words', ms: 450, price: 0.005 },
  // Lighthouse
  { build: 'lighthouse', tool: 'audit', params: 'example.com mobile', ms: 12000, price: 0.01 },
  { build: 'lighthouse', tool: 'seo', params: 'invoke-api.com', ms: 9500, price: 0.01 },
  // FFmpeg
  { build: 'ffmpeg', tool: 'convert', params: 'mp4 → mp3', ms: 3400, price: 0.02 },
  { build: 'ffmpeg', tool: 'thumbnail', params: 'frame @00:05', ms: 890, price: 0.02 },
  { build: 'ffmpeg', tool: 'probe', params: 'video.mp4 info', ms: 240, price: 0.02 },
  // ImageSorcery
  { build: 'imagesorcery', tool: 'resize', params: '1920→800px webp', ms: 180, price: 0.005 },
  { build: 'imagesorcery', tool: 'optimize', params: 'PNG 2.1MB→340KB', ms: 320, price: 0.005 },
  { build: 'imagesorcery', tool: 'watermark', params: 'Copyright 2026', ms: 210, price: 0.005 },
  // OpenMeteo
  { build: 'openmeteo', tool: 'forecast', params: 'London 7-day', ms: 280, price: 0.003 },
  { build: 'openmeteo', tool: 'current', params: 'Sofia, BG', ms: 190, price: 0.003 },
  { build: 'openmeteo', tool: 'airquality', params: 'NYC PM2.5', ms: 220, price: 0.003 },
  // MarkItDown
  { build: 'markitdown', tool: 'pdf', params: '12-page report', ms: 2800, price: 0.008 },
  { build: 'markitdown', tool: 'docx', params: 'contract.docx', ms: 640, price: 0.008 },
  { build: 'markitdown', tool: 'xlsx', params: '3 sheets → MD', ms: 380, price: 0.008 },
  // PIIRedaction
  { build: 'piiredaction', tool: 'redact', params: '2 emails, 1 SSN', ms: 45, price: 0.005 },
  { build: 'piiredaction', tool: 'analyze', params: 'risk: critical', ms: 38, price: 0.005 },
  // Geolocation
  { build: 'geolocation', tool: 'geocode', params: 'Eiffel Tower', ms: 310, price: 0.003 },
  { build: 'geolocation', tool: 'distance', params: 'NYC↔LA 3,944km', ms: 12, price: 0.003 },
  { build: 'geolocation', tool: 'ip_locate', params: '8.8.8.8 → US', ms: 180, price: 0.003 },
  // SSLScanner
  { build: 'sslscanner', tool: 'full_scan', params: 'github.com A+', ms: 1400, price: 0.008 },
  { build: 'sslscanner', tool: 'ssl', params: 'google.com 62d left', ms: 680, price: 0.008 },
  { build: 'sslscanner', tool: 'headers', params: 'HSTS ✓ CSP ✓', ms: 420, price: 0.008 },
  // Social Uploads
  { build: 'telegram-upload', tool: 'sendPhoto', params: 'AI art → channel', ms: 320, price: 0.01 },
  { build: 'telegram-upload', tool: 'sendVideo', params: 'kling clip → group', ms: 890, price: 0.01 },
  { build: 'discord-upload', tool: 'webhook', params: 'embed + image', ms: 210, price: 0.01 },
  { build: 'discord-upload', tool: 'webhook', params: 'daily report', ms: 180, price: 0.01 },
  { build: 'twitter-upload', tool: 'tweet', params: 'AI art + caption', ms: 1400, price: 0.01 },
  { build: 'twitter-upload', tool: 'tweet', params: 'video clip post', ms: 3200, price: 0.01 },
];

function generateActivity() {
  const t = SAMPLE_TOOLS[Math.floor(Math.random() * SAMPLE_TOOLS.length)];
  const jitter = Math.floor(Math.random() * (t.ms * 0.3)) - (t.ms * 0.15);
  return {
    id: Date.now() + Math.random(),
    build: t.build,
    tool: t.tool,
    params: t.params,
    ms: Math.max(10, Math.round(t.ms + jitter)),
    price: t.price || 0.01,
    ok: Math.random() > 0.02,
    time: new Date(),
  };
}

// ─── Command Palette ────────────────────────────────────────────────────
function CommandPalette({ open, onClose, builds, navigate }) {
  const [query, setQuery] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    if (open && inputRef.current) {
      setQuery('');
      setTimeout(() => inputRef.current?.focus(), 50);
    }
  }, [open]);

  useEffect(() => {
    function onKey(e) {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        if (open) onClose(); else onClose('toggle');
      }
      if (e.key === 'Escape' && open) onClose();
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  const q = query.toLowerCase();
  const isCommand = q.startsWith('>');
  const commands = [
    { label: 'Get API Key', action: () => navigate('getkey'), icon: '>' },
    { label: 'Publish a Build', action: () => navigate('register'), icon: '>' },
    { label: 'My Account', action: () => navigate('consumer'), icon: '>' },
    { label: 'Dashboard', action: () => navigate('dashboard'), icon: '>' },
    { label: 'API Docs', action: () => navigate('builder-docs'), icon: '>' },
    { label: 'Sign In', action: () => navigate('signin'), icon: '>' },
  ];

  const filtered = isCommand
    ? commands.filter(c => c.label.toLowerCase().includes(q.slice(1)))
    : builds.filter(b =>
        b.name.toLowerCase().includes(q) ||
        b.slug.toLowerCase().includes(q) ||
        b.description?.toLowerCase().includes(q) ||
        b.tags?.some(t => t.toLowerCase().includes(q))
      ).slice(0, 8);

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(8px)',
      display: 'flex', justifyContent: 'center', paddingTop: '15vh',
    }} onClick={onClose}>
      <div style={{
        width: '100%', maxWidth: 580, background: '#0d0f14',
        border: '1px solid rgba(124,111,239,0.25)', borderRadius: 16,
        boxShadow: '0 24px 80px rgba(0,0,0,0.6), 0 0 60px rgba(124,111,239,0.08)',
        overflow: 'hidden', maxHeight: '60vh',
      }} onClick={e => e.stopPropagation()}>
        {/* Input */}
        <div style={{
          display: 'flex', alignItems: 'center', padding: '14px 18px',
          borderBottom: '1px solid rgba(255,255,255,0.06)',
        }}>
          <span style={{
            fontFamily: "'JetBrains Mono', monospace", fontSize: 14,
            color: 'rgba(124,111,239,0.6)', marginRight: 10, flexShrink: 0,
          }}>$</span>
          <input
            ref={inputRef}
            value={query}
            onChange={e => setQuery(e.target.value)}
            placeholder="Search builds or type > for commands..."
            style={{
              flex: 1, background: 'none', border: 'none', outline: 'none',
              color: '#e2e8f0', fontSize: 15,
              fontFamily: "'JetBrains Mono', 'Fira Code', monospace",
            }}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                if (isCommand && filtered.length > 0) {
                  filtered[0].action();
                  onClose();
                } else if (!isCommand && filtered.length > 0) {
                  navigate('build', filtered[0].slug);
                  onClose();
                }
              }
            }}
          />
          <kbd style={{
            padding: '2px 8px', borderRadius: 4, fontSize: 11,
            background: 'rgba(255,255,255,0.06)', color: 'rgba(255,255,255,0.3)',
            border: '1px solid rgba(255,255,255,0.08)', fontFamily: 'monospace',
          }}>ESC</kbd>
        </div>

        {/* Results */}
        <div style={{ maxHeight: 340, overflowY: 'auto', padding: '6px 0' }}>
          {isCommand ? (
            filtered.map((cmd, i) => (
              <div key={i} onClick={() => { cmd.action(); onClose(); }} style={{
                padding: '10px 18px', cursor: 'pointer', display: 'flex', gap: 10, alignItems: 'center',
                background: i === 0 ? 'rgba(124,111,239,0.08)' : 'transparent',
              }}>
                <span style={{
                  fontFamily: 'monospace', fontSize: 12, color: 'rgba(124,111,239,0.5)',
                  width: 20, textAlign: 'center',
                }}>{cmd.icon}</span>
                <span style={{ color: '#e2e8f0', fontSize: 14 }}>{cmd.label}</span>
              </div>
            ))
          ) : (
            filtered.map((b, i) => (
              <div key={b.id} onClick={() => { navigate('build', b.slug); onClose(); }} style={{
                padding: '10px 18px', cursor: 'pointer', display: 'flex', gap: 12, alignItems: 'center',
                background: i === 0 ? 'rgba(124,111,239,0.08)' : 'transparent',
              }}>
                <span style={{
                  width: 8, height: 8, borderRadius: '50%', flexShrink: 0,
                  background: b.is_live ? '#22c55e' : '#64748b',
                  boxShadow: b.is_live ? '0 0 8px rgba(34,197,94,0.4)' : 'none',
                }} />
                <div style={{ flex: 1 }}>
                  <div style={{ color: '#e2e8f0', fontSize: 14, fontWeight: 500 }}>{b.name}</div>
                  <div style={{
                    fontSize: 12, color: 'rgba(255,255,255,0.35)',
                    fontFamily: 'monospace', marginTop: 2,
                  }}>{b.slug} · ${b.price_per_call}/call</div>
                </div>
                {b.badge && (
                  <span style={{
                    padding: '2px 8px', borderRadius: 99, fontSize: 10, fontWeight: 600,
                    background: 'rgba(245,158,11,0.12)', color: '#f59e0b',
                  }}>
                    {b.badge.split(',')[0]}
                  </span>
                )}
              </div>
            ))
          )}
          {filtered.length === 0 && (
            <div style={{ padding: '24px 18px', textAlign: 'center', color: 'rgba(255,255,255,0.25)', fontSize: 13 }}>
              No results
            </div>
          )}
        </div>

        {/* Footer hint */}
        <div style={{
          padding: '8px 18px', borderTop: '1px solid rgba(255,255,255,0.06)',
          display: 'flex', gap: 16, fontSize: 11, color: 'rgba(255,255,255,0.2)',
        }}>
          <span><kbd style={{ padding: '1px 4px', borderRadius: 3, background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.08)' }}>↵</kbd> open</span>
          <span><kbd style={{ padding: '1px 4px', borderRadius: 3, background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.08)' }}>&gt;</kbd> commands</span>
        </div>
      </div>
    </div>
  );
}

// ─── Live Activity Ticker ──────────────────────────────────────────────
function ActivityTicker() {
  const [activities, setActivities] = useState(() =>
    Array.from({ length: 6 }, () => generateActivity())
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setActivities(prev => {
        const next = [generateActivity(), ...prev];
        return next.slice(0, 12);
      });
    }, 2200 + Math.random() * 1800);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{
      fontFamily: "'JetBrains Mono', 'Fira Code', monospace",
      fontSize: 12, lineHeight: 1.9,
      background: '#080a0e',
      border: '1px solid rgba(255,255,255,0.06)',
      borderRadius: 12, padding: '14px 18px',
      maxHeight: 200, overflow: 'hidden',
      position: 'relative',
      maskImage: 'linear-gradient(to bottom, transparent 0%, black 15%, black 70%, transparent 100%)',
      WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, black 15%, black 70%, transparent 100%)',
    }}>
      {activities.map((a, i) => (
        <div key={a.id} style={{
          display: 'flex', gap: 8, alignItems: 'center',
          opacity: Math.max(0.15, 1 - i * 0.12),
          transition: 'opacity 0.5s',
        }}>
          <span style={{ color: 'rgba(124,111,239,0.5)' }}>{'→'}</span>
          <span style={{ color: '#7c6fef', minWidth: 160 }}>{a.build}</span>
          <span style={{ color: 'rgba(255,255,255,0.4)', minWidth: 100 }}>{a.tool}</span>
          <span style={{ color: 'rgba(255,255,255,0.2)', flex: 1 }}>{a.params}</span>
          <span style={{ color: 'rgba(255,255,255,0.2)' }}>${a.price.toFixed(2)}</span>
          <span style={{
            color: a.ms < 200 ? '#22c55e' : a.ms < 500 ? '#facc15' : '#f97316',
            minWidth: 50, textAlign: 'right',
          }}>{a.ms}ms</span>
          <span style={{
            color: a.ok ? '#22c55e' : '#ef4444',
            fontWeight: 600,
          }}>{a.ok ? '✓' : '✗'}</span>
        </div>
      ))}
    </div>
  );
}

// ─── Terminal Build Card ────────────────────────────────────────────────
function TerminalCard({ build, navigate, budget }) {
  const [hovered, setHovered] = useState(false);
  const [typed, setTyped] = useState('');
  const fullCmd = `$ invoke ${build.slug}`;

  useEffect(() => {
    if (!hovered) { setTyped(''); return; }
    let i = 0;
    const interval = setInterval(() => {
      i++;
      setTyped(fullCmd.slice(0, i));
      if (i >= fullCmd.length) clearInterval(interval);
    }, 35);
    return () => clearInterval(interval);
  }, [hovered, fullCmd]);

  const callsForBudget = Math.floor(budget / build.price_per_call);

  // Ambient glow based on live status
  const glowColor = build.is_live ? 'rgba(34,197,94,0.12)' : 'rgba(100,116,139,0.08)';
  const borderColor = hovered
    ? 'rgba(124,111,239,0.4)'
    : build.is_live
      ? 'rgba(34,197,94,0.15)'
      : 'rgba(255,255,255,0.06)';

  return (
    <div
      onClick={() => navigate('build', build.slug)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: '#0d0f14',
        border: `1px solid ${borderColor}`,
        borderRadius: 12, cursor: 'pointer',
        transition: 'all 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
        transform: hovered ? 'translateY(-3px)' : 'none',
        boxShadow: hovered
          ? `0 12px 40px rgba(0,0,0,0.4), 0 0 30px ${glowColor}`
          : build.is_live
            ? `0 0 20px ${glowColor}`
            : 'none',
        overflow: 'hidden',
        position: 'relative',
        // Ambient breathing animation for live builds
        animation: build.is_live ? 'breathe 4s ease-in-out infinite' : 'none',
      }}
    >
      {/* Terminal title bar */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: 6,
        padding: '10px 14px', borderBottom: '1px solid rgba(255,255,255,0.04)',
        background: 'rgba(255,255,255,0.02)',
      }}>
        <span style={{
          width: 10, height: 10, borderRadius: '50%',
          background: build.is_live ? '#22c55e' : '#64748b',
          boxShadow: build.is_live ? '0 0 8px rgba(34,197,94,0.5)' : 'none',
          transition: 'all 0.5s',
        }} />
        <span style={{
          width: 10, height: 10, borderRadius: '50%',
          background: 'rgba(234,179,8,0.6)',
        }} />
        <span style={{
          width: 10, height: 10, borderRadius: '50%',
          background: 'rgba(239,68,68,0.4)',
        }} />
        <span style={{
          flex: 1, textAlign: 'center',
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: 11, color: 'rgba(255,255,255,0.25)', letterSpacing: '0.02em',
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
        }}>
          {build.slug}
          {build.provider_type === 'platform' && (
            <span style={{
              fontSize: 8, fontWeight: 700, letterSpacing: '0.08em',
              padding: '1px 5px', borderRadius: 3,
              background: 'rgba(124,111,239,0.15)', color: '#a78bfa',
              border: '1px solid rgba(124,111,239,0.2)',
            }}>PLATFORM</span>
          )}
        </span>
        {/* Uptime as tiny bar */}
        <span style={{
          fontSize: 10, color: 'rgba(255,255,255,0.2)',
          fontFamily: 'monospace',
        }}>{build.uptime_pct?.toFixed(0) ?? 100}%</span>
      </div>

      {/* Terminal body */}
      <div style={{
        padding: '16px 16px 14px',
        fontFamily: "'JetBrains Mono', 'Fira Code', monospace",
      }}>
        {/* Build name + creator */}
        <div style={{ marginBottom: 10 }}>
          <div style={{
            fontSize: 16, fontWeight: 600, color: '#e2e8f0',
            marginBottom: 3, fontFamily: 'inherit',
          }}>
            {build.name}
          </div>
          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.25)' }}>
            by {build.creator_name}
          </div>
        </div>

        {/* Description as comment */}
        <div style={{
          fontSize: 12, color: 'rgba(255,255,255,0.3)',
          lineHeight: 1.6, marginBottom: 12,
          display: '-webkit-box', WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical', overflow: 'hidden',
        }}>
          <span style={{ color: 'rgba(124,111,239,0.4)' }}>// </span>
          {build.description}
        </div>

        {/* Tags as flags */}
        {build.tags?.length > 0 && (
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 14 }}>
            {build.tags.slice(0, 4).map(t => (
              <span key={t} style={{
                padding: '2px 8px', borderRadius: 4, fontSize: 10,
                background: 'rgba(124,111,239,0.08)',
                color: 'rgba(124,111,239,0.6)',
                border: '1px solid rgba(124,111,239,0.12)',
                fontFamily: 'monospace',
              }}>--{t}</span>
            ))}
          </div>
        )}

        {/* Trust badges */}
        {build.badge && (
          <div style={{ display: 'flex', gap: 6, marginBottom: 12 }}>
            {build.badge.split(',').map(b => {
              const info = {
                power_builder: { label: 'POWER', color: '#f59e0b' },
                fast: { label: 'FAST', color: '#22c55e' },
                reliable: { label: 'RELIABLE', color: '#3b82f6' },
              }[b.trim()];
              if (!info) return null;
              return (
                <span key={b} style={{
                  padding: '2px 6px', borderRadius: 3, fontSize: 9, fontWeight: 700,
                  background: `${info.color}15`, color: info.color,
                  fontFamily: 'monospace', letterSpacing: '0.05em',
                }}>{info.label}</span>
              );
            })}
          </div>
        )}

        {/* Hover: typed command */}
        <div style={{
          height: 24, marginBottom: 8,
          fontFamily: 'monospace', fontSize: 12,
          color: '#7c6fef',
          transition: 'opacity 0.2s',
          opacity: hovered ? 1 : 0,
        }}>
          {typed}<span style={{
            display: 'inline-block', width: 7, height: 14,
            background: '#7c6fef', marginLeft: 1,
            animation: 'blink 1s step-end infinite',
            verticalAlign: 'middle',
          }} />
        </div>

        {/* Price row */}
        <div style={{
          borderTop: '1px solid rgba(255,255,255,0.04)',
          paddingTop: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        }}>
          <div>
            <span style={{
              fontSize: 20, fontWeight: 700,
              background: 'linear-gradient(135deg, #a78bfa, #7c6fef)',
              WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
            }}>
              ${build.price_per_call.toFixed(2)}
            </span>
            <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.2)', marginLeft: 4 }}>/call</span>
          </div>
          <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
            {build.tools_count > 0 && (
              <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.25)', fontFamily: 'monospace' }}>
                {build.tools_count} tools
              </span>
            )}
            <span style={{
              fontSize: 11, color: 'rgba(255,255,255,0.15)',
              background: 'rgba(255,255,255,0.04)', padding: '3px 8px', borderRadius: 4,
              fontFamily: 'monospace',
            }}>
              ${budget} = {callsForBudget.toLocaleString()} calls
            </span>
          </div>
        </div>

        {/* Rating */}
        {build.rating > 0 && (
          <div style={{ marginTop: 8, fontSize: 11, display: 'flex', gap: 4, alignItems: 'center' }}>
            <span style={{ color: '#facc15' }}>★</span>
            <span style={{ color: 'rgba(255,255,255,0.4)' }}>{build.rating}</span>
            <span style={{ color: 'rgba(255,255,255,0.15)' }}>({build.rating_count})</span>
          </div>
        )}
      </div>
    </div>
  );
}


// ─── Category mapping — assigns each build to a browsing category ─────
const CATEGORIES = [
  { key: 'all',      label: 'All',           icon: '◈' },
  { key: 'video',    label: 'Video',         icon: '▶' },
  { key: 'image',    label: 'Image',         icon: '◧' },
  { key: 'audio',    label: 'Audio & Speech', icon: '♫' },
  { key: 'language', label: 'Language',       icon: '⟐' },
  { key: 'search',   label: 'Search',        icon: '⊘' },
  { key: 'social',   label: 'Social',        icon: '↗' },
  { key: 'data',     label: 'Data & Tools',  icon: '⚙' },
];

const TAG_TO_CATEGORY = {
  // Video
  'video': 'video', 'ai-video': 'video', 'text-to-video': 'video', 'image-to-video': 'video',
  'video-generation': 'video', 'lipsync': 'video', 'lip-sync': 'video', 'face-animation': 'video',
  'avatar': 'video', 'dubbing': 'video', 'kling': 'video', 'minimax': 'video', 'pixverse': 'video',
  'sora': 'video', 'veo': 'video', 'hailuo': 'video', 'hunyuan': 'video', 'wan': 'video',
  'cinematic': 'video',
  // Image
  'image': 'image', 'ai-image': 'image', 'text-to-image': 'image', 'image-generation': 'image',
  'image-editing': 'image', 'inpainting': 'image', 'flux': 'image', 'ideogram': 'image',
  'kontext': 'image', 'ai-art': 'image', 'design': 'image', 'creative': 'image',
  'black-forest-labs': 'image', 'typography': 'image', 'logo': 'image', 'poster': 'image',
  'schnell': 'image', 'high-quality': 'image', 'pro': 'image', 'stylized': 'image', 'artistic': 'image',
  '3d': 'image', '3d-model': 'image', 'text-to-3d': 'image', 'image-to-3d': 'image',
  'glb': 'image', 'fbx': 'image', 'obj': 'image', 'tripo': 'image', 'game-assets': 'image',
  'ar': 'image', 'vr': 'image',
  // Audio & Speech
  'audio': 'audio', 'voice': 'audio', 'tts': 'audio', 'text-to-speech': 'audio',
  'speech-synthesis': 'audio', 'speech-to-text': 'audio', 'stt': 'audio', 'transcription': 'audio',
  'deepgram': 'audio', 'diarization': 'audio', 'nova-2': 'audio', 'music': 'audio',
  'musicgen': 'audio', 'text-to-music': 'audio', 'ai-music': 'audio', 'sound': 'audio',
  'sound-effects': 'audio', 'elevenlabs': 'audio', 'premium-voice': 'audio', 'ai-voice': 'audio',
  'inworld': 'audio', 'character-voice': 'audio', 'game-audio': 'audio',
  'voiceover': 'audio', 'podcast': 'audio',
  // Language
  'llm': 'language', 'ai-chat': 'language', 'chat': 'language', 'code': 'language',
  'fast-llm': 'language', 'reasoning': 'language', 'math': 'language', 'inference': 'language',
  'groq': 'language', 'llama': 'language', 'llama-3': 'language', 'llama-4': 'language',
  'meta': 'language', 'qwen': 'language', 'deepseek': 'language', 'deepseek-r1': 'language',
  'gemini': 'language', 'google': 'language', 'open-source': 'language', 'moe': 'language',
  '70b': 'language', 'embeddings': 'language', 'cheap': 'language',
  // Search
  'search': 'search', 'ai-search': 'search', 'web-search': 'search', 'research': 'search',
  'perplexity': 'search', 'sonar': 'search', 'sonar-pro': 'search', 'deep-research': 'search',
  'citations': 'search', 'analysis': 'search',
  // Data & Tools
  'crypto': 'data', 'market-data': 'data', 'OHLCV': 'data', 'analytics': 'data',
  'backtesting': 'data', 'real-time': 'data', 'stocks': 'data', 'forex': 'data',
  'finance': 'data', 'fundamentals': 'data', 'earnings': 'data', 'news': 'data', 'currency': 'data',
  'scraping': 'data', 'web': 'data', 'crawl': 'data', 'markdown': 'data', 'extract': 'data',
  'sitemap': 'data', 'data': 'data', 'sandbox': 'data', 'execution': 'data', 'python': 'data',
  'compute': 'data', 'agent': 'data', 'safe': 'data', 'qr-code': 'data', 'generator': 'data',
  'email': 'data', 'validation': 'data', 'sales': 'data', 'leads': 'data', 'verification': 'data',
  'hash': 'data', 'security': 'data', 'developer': 'data', 'encoding': 'data',
  'url': 'data', 'shortener': 'data', 'links': 'data', 'tracking': 'data',
  'utility': 'data', 'replicate': 'data', 'content': 'data', 'marketing': 'data',
  // Social
  'social': 'social', 'upload': 'social', 'automation': 'social', 'telegram': 'social',
  'discord': 'social', 'twitter': 'social', 'x': 'social', 'tweet': 'social',
  'webhook': 'social', 'messaging': 'social', 'posting': 'social', 'auto-post': 'social',
};

function getBuildCategory(build) {
  const tags = build.tags || [];
  const counts = {};
  for (const t of tags) {
    const cat = TAG_TO_CATEGORY[t];
    if (cat) counts[cat] = (counts[cat] || 0) + 1;
  }
  let best = null, bestN = 0;
  for (const [cat, n] of Object.entries(counts)) {
    if (n > bestN) { best = cat; bestN = n; }
  }
  return best || 'data';
}

// ─── Main Marketplace ──────────────────────────────────────────────────
export default function Marketplace({ navigate }) {
  const [builds, setBuilds]       = useState([]);
  const [loading, setLoading]     = useState(true);
  const [fetchError, setFetchError] = useState(false);
  const [search, setSearch]       = useState('');
  const [activeCategory, setActiveCategory] = useState('all');
  const [budget, setBudget]       = useState(10);
  const [paletteOpen, setPaletteOpen] = useState(false);

  useEffect(() => {
    fetch('/v1/builds')
      .then(r => r.json())
      .then(d => { setBuilds(d.builds || []); setLoading(false); })
      .catch(() => { setLoading(false); setFetchError(true); });
  }, []);

  const handlePaletteClose = useCallback((action) => {
    if (action === 'toggle') setPaletteOpen(p => !p);
    else setPaletteOpen(false);
  }, []);

  const filtered = builds.filter(b => {
    const q = search.toLowerCase();
    const matchSearch = !q || b.name.toLowerCase().includes(q) ||
      b.description?.toLowerCase().includes(q) ||
      b.tags?.some(t => t.toLowerCase().includes(q));
    const matchCategory = activeCategory === 'all' || getBuildCategory(b) === activeCategory;
    return matchSearch && matchCategory;
  });

  const onlineCount = builds.filter(b => b.is_live).length;

  return (
    <div>
      {/* ── Inject keyframe animations ── */}
      <style>{`
        @keyframes breathe {
          0%, 100% { box-shadow: 0 0 15px rgba(34,197,94,0.06); }
          50% { box-shadow: 0 0 25px rgba(34,197,94,0.12); }
        }
        @keyframes blink {
          0%, 100% { opacity: 1; }
          50% { opacity: 0; }
        }
        @keyframes slideIn {
          from { opacity: 0; transform: translateY(8px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes pulseGlow {
          0%, 100% { opacity: 0.4; }
          50% { opacity: 0.8; }
        }
      `}</style>

      {/* ── Command Palette ── */}
      <CommandPalette
        open={paletteOpen}
        onClose={handlePaletteClose}
        builds={builds}
        navigate={navigate}
      />

      {/* ── Hero: Terminal-style ── */}
      <div style={{ marginBottom: 36, paddingTop: 8 }}>
        <div style={{
          display: 'flex', alignItems: 'center', gap: 10, marginBottom: 18,
        }}>
          <span style={{
            width: 8, height: 8, borderRadius: '50%', background: '#22c55e',
            boxShadow: '0 0 10px rgba(34,197,94,0.5)',
            animation: 'pulseGlow 3s ease-in-out infinite',
          }} />
          <span style={{
            fontSize: 12, fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase',
            color: 'rgba(255,255,255,0.35)',
            fontFamily: "'JetBrains Mono', monospace",
          }}>
            {onlineCount} API{onlineCount !== 1 ? 's' : ''} live · {builds.length} total
          </span>
        </div>

        <h1 style={{
          fontSize: 42, fontWeight: 700, lineHeight: 1.2, marginBottom: 6,
          letterSpacing: '-0.03em', color: '#e2e8f0',
        }}>
          One API.{' '}
          <span style={{
            background: 'linear-gradient(135deg, #a78bfa, #7c6fef, #6558d4)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
          }}>
            All AI.
          </span>
        </h1>
        <h2 style={{
          fontSize: 22, fontWeight: 500, lineHeight: 1.3, marginBottom: 18,
          letterSpacing: '-0.01em', color: 'rgba(255,255,255,0.3)',
        }}>
          Images, video, speech, search, data —{' '}
          <span style={{ color: '#22c55e' }}>one key, one format.</span>
        </h2>

        <p style={{
          color: 'rgba(255,255,255,0.25)', fontSize: 14, maxWidth: 520,
          lineHeight: 1.7, marginBottom: 20,
          fontFamily: "'JetBrains Mono', monospace",
        }}>
          No vendor lock-in. No separate accounts. Pay per call, chain models together,
          and ship faster than juggling 5 different provider SDKs.
        </p>

        {/* Cmd+K hint */}
        <div
          onClick={() => setPaletteOpen(true)}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 10,
            padding: '10px 18px', borderRadius: 10,
            background: 'rgba(255,255,255,0.03)',
            border: '1px solid rgba(255,255,255,0.06)',
            cursor: 'pointer', transition: 'all 0.2s',
            fontFamily: "'JetBrains Mono', monospace", fontSize: 13,
            color: 'rgba(255,255,255,0.25)',
          }}
        >
          <span style={{ color: 'rgba(124,111,239,0.5)' }}>$</span>
          <span>Search APIs...</span>
          <kbd style={{
            padding: '2px 8px', borderRadius: 4, fontSize: 11, marginLeft: 'auto',
            background: 'rgba(255,255,255,0.06)', color: 'rgba(255,255,255,0.2)',
            border: '1px solid rgba(255,255,255,0.08)',
          }}>⌘K</kbd>
        </div>
      </div>

      {/* ── Live Activity Ticker — only show when 3+ live builds exist ── */}
      {onlineCount >= 3 && (
        <div style={{ marginBottom: 36 }}>
          <div style={{
            fontSize: 11, fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase',
            color: 'rgba(255,255,255,0.2)', marginBottom: 10,
            fontFamily: "'JetBrains Mono', monospace",
            display: 'flex', alignItems: 'center', gap: 8,
          }}>
            <span style={{
              width: 6, height: 6, borderRadius: '50%', background: '#22c55e',
              animation: 'pulseGlow 2s ease-in-out infinite',
            }} />
            live activity
          </div>
          <ActivityTicker />
        </div>
      )}

      {/* ── Feature highlights ── */}
      <div style={{
        display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 14,
        marginBottom: 36,
      }}>
        {[
          { cmd: '$ get-key', title: 'One key, all models', desc: 'Unified auth across 40+ AI services. No separate accounts.', color: '#7c6fef', action: () => navigate('getkey') },
          { cmd: '$ chain', title: 'Chain models together', desc: 'Pipe image → video → voiceover in a single call.', color: '#a78bfa', action: null },
          { cmd: '$ pay-per-call', title: 'No subscriptions', desc: 'Credits from $5. Pay only for what you use.', color: '#22c55e', action: null },
          { cmd: '$ mcp', title: 'MCP-native', desc: 'Works with Claude, Cursor, and any MCP client out of the box.', color: '#f59e0b', action: null },
        ].map((f, i) => (
          <div
            key={i}
            onClick={f.action || undefined}
            style={{
              padding: '20px 22px', borderRadius: 12,
              cursor: f.action ? 'pointer' : 'default',
              background: `${f.color}08`,
              border: `1px solid ${f.color}1a`,
              transition: 'all 0.25s',
            }}
          >
            <div style={{
              fontFamily: "'JetBrains Mono', monospace", fontSize: 12,
              color: f.color, marginBottom: 6, opacity: 0.7,
            }}>{f.cmd}</div>
            <div style={{ fontSize: 14, fontWeight: 600, color: '#e2e8f0', marginBottom: 4 }}>
              {f.title}
            </div>
            <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.3)', lineHeight: 1.6 }}>
              {f.desc}
            </div>
          </div>
        ))}
      </div>

      {/* ── Category tabs + search ── */}
      <div style={{
        display: 'flex', gap: 10, marginBottom: 24, flexWrap: 'wrap', alignItems: 'center',
      }}>
        {/* Category pills */}
        <div style={{
          display: 'flex', gap: 4, flexWrap: 'wrap', flex: 1,
        }}>
          {CATEGORIES.map(cat => {
            const isActive = activeCategory === cat.key;
            const count = cat.key === 'all' ? builds.length : builds.filter(b => getBuildCategory(b) === cat.key).length;
            return (
              <button
                key={cat.key}
                onClick={() => setActiveCategory(cat.key)}
                style={{
                  padding: '7px 16px', borderRadius: 8,
                  border: `1px solid ${isActive ? 'rgba(124,111,239,0.3)' : 'rgba(255,255,255,0.06)'}`,
                  background: isActive ? 'rgba(124,111,239,0.12)' : 'rgba(255,255,255,0.02)',
                  color: isActive ? '#a78bfa' : 'rgba(255,255,255,0.3)',
                  cursor: 'pointer', fontSize: 12, fontWeight: 500,
                  fontFamily: "'JetBrains Mono', monospace",
                  display: 'flex', alignItems: 'center', gap: 6,
                  transition: 'all 0.2s',
                }}
              >
                <span style={{ fontSize: 13, opacity: isActive ? 1 : 0.5 }}>{cat.icon}</span>
                {cat.label}
                <span style={{
                  fontSize: 10, opacity: 0.4, marginLeft: 2,
                }}>{count}</span>
              </button>
            );
          })}
        </div>

        {/* Search */}
        <div style={{ minWidth: 200, position: 'relative' }}>
          <span style={{
            position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)',
            color: 'rgba(124,111,239,0.4)', fontSize: 13, pointerEvents: 'none',
            fontFamily: 'monospace',
          }}>$</span>
          <input
            style={{
              width: '100%', padding: '9px 14px 9px 28px',
              borderRadius: 8, border: '1px solid rgba(255,255,255,0.06)',
              background: 'rgba(255,255,255,0.02)', color: '#e2e8f0', fontSize: 13,
              fontFamily: "'JetBrains Mono', monospace", outline: 'none',
            }}
            placeholder="filter APIs..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            onFocus={e => e.target.style.borderColor = 'rgba(124,111,239,0.3)'}
            onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.06)'}
          />
        </div>
      </div>

      {/* ── Build Grid ── */}
      {loading ? (
        <div style={{
          color: 'rgba(255,255,255,0.25)', padding: '60px 0', textAlign: 'center',
          fontFamily: "'JetBrains Mono', monospace", fontSize: 13,
        }}>
          <div style={{ marginBottom: 8, animation: 'blink 1s step-end infinite' }}>▋</div>
          loading builds...
        </div>
      ) : fetchError ? (
        <div style={{
          textAlign: 'center', padding: '60px 0',
          fontFamily: "'JetBrains Mono', monospace",
        }}>
          <div style={{ color: '#ef4444', fontSize: 14, marginBottom: 8 }}>error: could not load builds</div>
          <button onClick={() => window.location.reload()} style={{
            padding: '8px 20px', borderRadius: 8,
            border: '1px solid rgba(255,255,255,0.1)', background: 'transparent',
            color: 'rgba(255,255,255,0.4)', cursor: 'pointer', fontFamily: 'monospace', fontSize: 12,
          }}>retry</button>
        </div>
      ) : (
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
          gap: 16,
        }}>
          {filtered.length === 0 ? (
            <div style={{
              gridColumn: '1/-1', textAlign: 'center', padding: '60px 0',
              fontFamily: "'JetBrains Mono', monospace", fontSize: 13,
              color: 'rgba(255,255,255,0.2)',
            }}>
              no APIs match "{search}"
            </div>
          ) : (
            filtered.map(b => (
              <TerminalCard key={b.id} build={b} navigate={navigate} budget={budget} />
            ))
          )}
        </div>
      )}
    </div>
  );
}
